import React, { useState } from "react";

import { useGetPartner, useParams } from "utils";

import { AdminHead, Col, MainPage, Row, Spin, Tabs } from "components";

import { AttachFarmers } from "pages/admin/partners/components/AttachFarmers";
import { PartnerCredits } from "pages/admin/partners/components/PartnerCredits";
import { PartnerSettings } from "pages/admin/partners/components/PartnerSettings";

export const PartnerUpdate = () => {
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("details");
  const partnerQuery = useGetPartner(id);

  const partner = partnerQuery.data;
  if (!partner || partnerQuery.isLoading) {
    return <Spin>Loading</Spin>;
  }

  return (
    <MainPage loading={partnerQuery.isLoading} pageName={"admin"}>
      <AdminHead
        headline={partner?.name}
        link="/partners/partners"
        tooltipText="Back to partners"
        description="Update a partner here. The hectare limit is the maximum amount of hectares to which methods can be applied, per-farm. This will override the default hectare limit for any farm which has been attached to this partner. The point price is the amount which this partner will partner will pay per kg of carbon sequestered by any farmer attached to this partner."
      />
      <Row>
        <Col>
          <Tabs
            activeKey={activeTab}
            onChange={(tab) => setActiveTab(tab)}
            size="small"
            items={[
              {
                label: "Credits",
                key: "credits",
                children: partner && !partner.disabled && <PartnerCredits partner={partner} onUpdateSuccess={() => partnerQuery.refetch()} />,
                disabled: !(partner && !partner.disabled),
              },
              {
                label: "Farmers",
                key: "farmers",
                children: partner && !partner.disabled && <AttachFarmers partner={partner} onUpdateSuccess={() => partnerQuery.refetch()} />,
                disabled: !(partner && !partner.disabled),
              },
              {
                label: "Partner details",
                key: "details",
                children: <PartnerSettings partner={partner} onUpdateSuccess={() => partnerQuery.refetch()} />,
              },
            ]}
          />
        </Col>
      </Row>
    </MainPage>
  );
};
